
export default {
  UPDATE_DRIVERS ( state, drivers){
    state.drivers = drivers
  },
  SET_CURRENT_PAGE(state, payload) {
    state.currentPage = payload
  },
  SET_FILTERS(state, payload){
    state.filters = payload;
  }
}
